import React, { useEffect, useState } from "react";
import { setupStageLabel, setupTimeRemaining } from "../modules/snapshotAgentSetup";

export default function WorkspaceSetupProgress({ setup, finishedAt, isRunning, uncertain = false, classes, formatDuration }) {
  const isPreparing = !uncertain && isRunning && setup?.status === "running";
  const [, tick] = useState(0);
  useEffect(() => {
    if (!isPreparing) return undefined;
    const timer = setInterval(() => tick((n) => n + 1), 1000);
    if (uncertain && setup.status === "running") return (
    <div className={classes.silentNote} role="status">
      <strong>Waiting for current workspace status</strong>
      <div>Last reported stage: {setupStageLabel(setup.stage)}</div>
    </div>
  );
  return () => clearInterval(timer);
  }, [isPreparing]);
  if (!setup || setup.status === "completed") return null;
  return (
    <div className={classes.silentNote} role="status" aria-label="Workspace setup">
    <strong>{isPreparing ? "Preparing workspace" : "Setup stopped"}</strong>
    <div style={{ marginTop: 6 }}>{setupStageLabel(setup.stage)}</div>
    {setup.detail ? (
      <div className={classes.silentNoteHint}>
        {setup.detail.phase} · {setup.detail.percent}% ({setup.detail.completed}/{setup.detail.total})
        {setup.detail.transferred ? ` · ${setup.detail.transferred}` : ""}
        {setup.detail.speed ? ` · ${setup.detail.speed}` : ""}
        <progress aria-label={setup.detail.phase} max={100} value={setup.detail.percent}
          style={{ display: "block", width: "100%", height: 6, marginTop: 8, accentColor: "#90caf9" }} />
      </div>
    ) : null}
    <div className={classes.silentNoteHint}>
      Elapsed {formatDuration(setup.startedAt, isPreparing ? null : finishedAt)}
      {isPreparing ? ` · ${setupTimeRemaining(setup.deadlineAt)} remaining` : ""}
    </div>
    {isPreparing ? (
      <div className={classes.silentNoteHint}>
        Last progress {formatDuration(setup.updatedAt, null)} ago. Stop cancels setup too.
      </div>
    ) : null}
  </div>
  );
}
